
import { post, get, put, del, token, DEV_TOKEN } from './api.js';
import { groupBy, mapBy } from "./utils.js";

export async function load(id, group) {

    if (group === undefined) {
        group = true;
    }

    let url = `games/${id}`;
    if (group) {
        url += "&items=true";
    }

    return get(url, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return group ? groupBy(d, "game_id") : d;
        })
        .catch(e => {
            return [];
        });
}

/* export async function check(id, admin_code) {
    return get(`games/${id}&admin_code=${admin_code}`, token || DEV_TOKEN);
} */

export async function loadGame(id, game_id) {
    return get(`games/${id}?game_id=${game_id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            return [];
        });
}

export async function loadGameForCode(id, code) {
    return get(`games/${id}?code=${code}`, token || DEV_TOKEN);
}

/**
 * Create Game.
 */
export function create(id, name, type, desc, duration, start, mode, image, progess_mode, penalty) {

    let payload = {
        name: name,
        type: type
    };

    if (desc) {
        payload.desc = desc;
    }

    if (duration) {
        payload.duration = duration;
    }

    if (start) {
        payload.start = start;
    }

    if (mode) {
        payload.mode = mode;
    }

    if (image) {
        payload.image = image;
    }

    if (progess_mode) {
        payload.progess_mode = progess_mode;
    }

    if (penalty) {
        payload.penalty = penalty;
    }

    return post(`games/${id}`, payload, token || DEV_TOKEN);
}

export function update(id, game_id, name, type, desc, duration, start, published, mode, image, progess_mode, penalty) {

    let payload = {
        game_id: game_id
    };

    if (name) {
        payload.name = name;
    }

    if (type) {
        payload.type = type;
    }

    if (desc) {
        payload.desc = desc;
    }

    if (duration) {
        payload.duration = duration;
    }

    if (start) {
        payload.start = start;
    }

    if (published) {
        payload.published = published;
    }

    if (mode) {
        payload.mode = mode;
    }

    if (image) {
        payload.image = image;
    }

    if (progess_mode) {
        payload.progess_mode = progess_mode;
    }

    if (penalty) {
        payload.penalty = penalty;
    }

    return put(`games/${id}`, payload, token || DEV_TOKEN);
}

/**
 * Add Item
 */
export function add(id, game_id, item_id, title, order, timeout, type, content, response) {
    return put(`games/${id}`,
        {
            game_id: game_id,
            addItem: true,
            item_id: item_id,
            title: title,
            order: order,
            timeout: timeout,
            type: type,
            content: content,
            response: response,
        }, token || DEV_TOKEN);
}

/**
 * Delete Game
 */
export function deleteGame(id, game_id, item_id) {

    let payload = {};
    if (game_id) {
        payload.game_id = game_id;
    }
    if (item_id) {
        payload.item_id = item_id;
    }
    return del(`games/${id}`, payload, token || DEV_TOKEN);
}

